import type { BasedFunctionConfig } from '@based/sdk/functions'

export default {
  type: 'query',
  name: 'list-service-provider',
  public: true,
} as BasedFunctionConfig
